interface CircleOutlineProps {
  size?: number;
  strokeWidth?: number;
  color?: 'primary' | 'secondary' | 'accent' | 'neutral';
  opacity?: number;
  animate?: boolean;
  concentric?: boolean;
  className?: string;
}

export function CircleOutline({
  size = 100,
  strokeWidth = 2.5,
  color = 'primary',
  opacity = 0.45,
  animate = false,
  concentric = false,
  className = ''
}: CircleOutlineProps) {
  const colorMap: Record<string, string> = {
    primary: 'var(--color-primary-500)',
    secondary: 'var(--color-secondary-500)',
    accent: '#10B981',
    neutral: '#64748b',
  };

  const animationStyle = animate ? {
    animation: 'float 10s ease-in-out infinite',
  } : {};

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      className={className}
      style={{ opacity, ...animationStyle }}
    >
      <circle
        cx={size / 2}
        cy={size / 2}
        r={(size / 2) - strokeWidth}
        stroke={colorMap[color]}
        strokeWidth={strokeWidth}
        fill="none"
      />
      {concentric && (
        <circle
          cx={size / 2}
          cy={size / 2}
          r={(size / 2) - strokeWidth - (size * 0.12)}
          stroke={colorMap[color]}
          strokeWidth={strokeWidth * 0.75}
          fill="none"
          opacity={0.7}
        />
      )}
    </svg>
  );
}
